module.exports = new __parcel__URL__("gooh_refinery_level_3.372bd5a7.png").toString();